import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-po-finish-prod-comp',
  templateUrl: './po-finish-prod-comp.component.html',
  styleUrls: ['./po-finish-prod-comp.component.css']
})
export class PoFinishProdCompComponent implements OnInit {
    p2PoFinishProdKeyno;

    public p2PoFinishProdCompKeyno: string;

    public productIdButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'product', gotoParms: () => this.edit!.prod_id ?? '' }];

    public edit?: Edit;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.p2PoFinishProdKeyno = this.stateService.getStateParams()['p2_pofinishprod_keyno'];
        this.p2PoFinishProdCompKeyno = this.stateService.getStateParams()['p2_pofinishprodcomp_keyno'];
    }

    private async loadEdit() {
        if (!!this.p2PoFinishProdKeyno && !!this.p2PoFinishProdCompKeyno) {
            this.edit = (await this.datatask.Post(167, {
                p2_pofinishprod_keyno: this.p2PoFinishProdKeyno,
                p2_pofinishprodcomp_keyno: this.p2PoFinishProdCompKeyno
            }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(178, {
                    p2_pofinishprodcomp_keyno: this.edit.p2_pofinishprodcomp_keyno,
                    quantity: this.edit.quantity
                });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(168, { p2_pofinishprodcomp_keyno: this.edit.p2_pofinishprodcomp_keyno });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    p2_pofinishprodcomp_keyno: string;
    prod_id: string;
    prod_name: string;
    prodsize_keyno: string;
    prodchoice_keyno: string;
    quantity: string;
    stock_keyno: string;
    quantity_picked: string;
    quantity_topick: string;
    prodname_long_top: string;
    show_button_pofinishprodcompassign: string;
    nbr_of_stockbatches_assigned: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('poFinishProdComp', {
//        templateUrl: 'views/components/views/poFinishProdComp/poFinishProdComp.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'poFinishProdCompService', function ($stateParams, stateService, modalService, translateService, poFinishProdCompService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let p2PoFinishProdKeyno = $stateParams.p2_pofinishprod_keyno;
//            let p2PoFinishProdCompKeyno = $stateParams.p2_pofinishprodcomp_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                p2PoFinishProdCompKeyno: p2PoFinishProdCompKeyno,
//                productIdButtons: [
//                    { id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('product', { prod_id: vm.model.edit.prod_id }) }
//                ],
//                edit: {},
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await poFinishProdCompService.getEdit({
//                    p2_pofinishprod_keyno: p2PoFinishProdKeyno,
//                    p2_pofinishprodcomp_keyno: p2PoFinishProdCompKeyno
//                }))[0];
//            }

//            // #endregion PROCEDURE CALLS

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    poFinishProdCompService.deleteItem({ p2_pofinishprodcomp_keyno: vm.model.edit.p2_pofinishprodcomp_keyno }).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                poFinishProdCompService.saveObj({
//                    p2_pofinishprodcomp_keyno: vm.model.edit.p2_pofinishprodcomp_keyno,
//                    quantity: vm.model.edit.quantity
//                }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
